import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function PaymentPage() {
  const { sessionId } = useParams();

  useEffect(() => {
    async function redirectToStripeCheckout() {
      // Ensure window.Stripe is available (in case the Stripe script hasn't loaded yet)
      if (!window.Stripe) {
        console.error('Stripe V3 library not loaded!');
        return;
      }

      // Initialize Stripe with your public key
      const stripe = window.Stripe ("pk_live_51HTKNAD4EwKsCcFfLsEvbIDghHRsyPflE5zJW5ChrD8yxje3QZdryvjLNRE7fBYS0E2ERc96bTooxiRdW90YKh2500Z4uxfqo4");

      // Redirect to Stripe's Checkout page using the sessionId
      const { error } = await stripe.redirectToCheckout({ sessionId });

      // If there's an error redirecting (e.g., the sessionId is invalid), you can handle it here
      if (error) {
        console.error('Failed to redirect to Stripe Checkout:', error.message);
      }
    }

    redirectToStripeCheckout();
  }, [sessionId]);

  return (
    <div>
      <h2>Redirecting to Stripe Checkout...</h2>
      {/* You can add a loading spinner or some informational text here */}
    </div>
  );
}

export default PaymentPage;
